import React from 'react';
import { styled } from 'styled-components';
import { ShowTeaserWrapper } from './ShowTeaserWrapper';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { getMultilineTruncation } from '../../../../../play-core/styles/style-helper';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShowTeaser = ({
  show,
  index,
  titleVisible = false,
  showPosterImage = false,
  onlyFavor = false,
  onChange,
  ...rest
}) => {
  const {
    displayShowTitles
  } = useVideoConfig();
  const aspectRatio = showPosterImage ? '2/3' : '16/9';
  return /*#__PURE__*/_jsx(ShowTeaserWrapper, {
    show: show,
    index: index,
    ariaLabel: show.title,
    aspectRatio: aspectRatio,
    onlyFavor: onlyFavor,
    ...rest,
    children: (displayShowTitles || titleVisible) && /*#__PURE__*/_jsx(Title, {
      children: show.title
    })
  });
};
const Title = styled.div.withConfig({
  displayName: "ShowTeaser__Title",
  componentId: "sc-6pgni7-0"
})(["margin-top:16px;", ";color:", ";", ";", "{", ";}"], Fonts.regular(18), Colors.GREY_d2d2d2, getMultilineTruncation(2, 24), Viewports.for('small'), Fonts.regular(16));